import React from 'react';
import { browserHistory } from 'react-router';

const ChooseWarning = ({ referral, webpageBase }) => (
  <div>
    <div className="modal-header">
      <h3>Choose New Location/Provider</h3>
    </div>
    <div className="modal-body">
      <p>
        {`You can change the recipient of this referral. This will withdraw the existing referral from ${
          referral.assigned
            ? referral.receivingProvider.nameWithAppellation
            : referral.receivingOrganization.name
        }${referral.booked ? ' and cancel the existing appointment.' : '.'}`}
      </p>
      <p>Do you wish to choose a new provider or location?</p>
    </div>
    <div className="modal-footer">
      <button
        className="btn btn-primary"
        onClick={() =>
          browserHistory.push(
            `${webpageBase}/referral_profiles/${referral.referralProfileId}/referral_dashboard`
          )
        }
      >
        Proceed
      </button>
    </div>
  </div>
);

ChooseWarning.displayName = 'ChooseWarning';

export default ChooseWarning;
